import classNames from 'classnames';
import './ribbon.scss';

const Ribbon = ({ children, className }) => {
  const componentClassName = classNames('uhc-ribbon', {}, className);
  return <div className={componentClassName}>{children}</div>;
};

export default Ribbon;
